module.exports = __webpack_public_path__ + "static/media/public.f16cd300.txt";